export async function resizeAvatar(
	file: File,
	maxSize = 256
): Promise<Blob> {
	return new Promise((resolve, reject) => {
		const img = new Image();
		const url = URL.createObjectURL(file);
		img.onload = () => {
			URL.revokeObjectURL(url);
			const canvas = document.createElement('canvas');
			const size = Math.min(img.width, img.height);
			canvas.width = maxSize;
			canvas.height = maxSize;
			const ctx = canvas.getContext('2d');
			if (!ctx) return reject(new Error('Canvas not supported'));

			// Composite over white background for transparent images (e.g. PNGs)
			ctx.fillStyle = '#ffffff';
			ctx.fillRect(0, 0, maxSize, maxSize);

			const sx = (img.width - size) / 2;
			const sy = (img.height - size) / 2;
			ctx.drawImage(img, sx, sy, size, size, 0, 0, maxSize, maxSize);

			canvas.toBlob((blob) => {
				if (blob) resolve(blob);
				else reject(new Error('Failed to create blob'));
			}, 'image/jpeg', 0.85);
		};
		img.onerror = () => reject(new Error('Failed to load image'));
		img.src = url;
	});
}

export async function compressAttachment(
	file: File,
	maxBytes = 20 * 1024 * 1024
): Promise<Blob> {
	const img = await loadImage(file);
	const { width, height } = img;

	let scale = 1;

	for (;;) {
		const w = Math.round(width * scale);
		const h = Math.round(height * scale);
		const blob = await renderToJpeg(img, w, h, 0.85);

		if (blob.size <= maxBytes || w <= 100 || h <= 100) return blob;
		scale *= 0.7071;
	}
}

function loadImage(file: File): Promise<HTMLImageElement> {
	return new Promise((resolve, reject) => {
		const img = new Image();
		const url = URL.createObjectURL(file);
		img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
		img.onerror = () => reject(new Error('Failed to load image'));
		img.src = url;
	});
}

function renderToJpeg(
	img: HTMLImageElement,
	width: number,
	height: number,
	quality: number
): Promise<Blob> {
	return new Promise((resolve, reject) => {
		const canvas = document.createElement('canvas');
		canvas.width = width;
		canvas.height = height;
		const ctx = canvas.getContext('2d');
		if (!ctx) return reject(new Error('Canvas not supported'));

		ctx.fillStyle = '#ffffff';
		ctx.fillRect(0, 0, width, height);
		ctx.drawImage(img, 0, 0, width, height);

		canvas.toBlob((blob) => {
			if (blob) resolve(blob);
			else reject(new Error('Failed to create blob'));
		}, 'image/jpeg', quality);
	});
}

